import { useEffect, useRef } from 'react';
import apiService from '../services/apiService';

const usePresencePing = (user, isWatchingVideo = false) => {
    const pingIntervalRef = useRef(null);
    const isTabActive = useRef(true);

    useEffect(() => {
        if (!user?.id || isWatchingVideo) {
            // ⚠️ Si on regarde une vidéo, VideoPlayer s'en occupe
            return;
        }

        const sendPresencePing = () => {
            if (!isTabActive.current) return;

            const payload = {
                user_id: user.id,
                username: user.username,
                movie_id: null,
                movie_title: null,
                type: null,
                season: null,
                episode: null,
                current_time: null,
                duration: null,
            };

            apiService.sendSessionPing(payload).catch(err => {
                console.error('Erreur ping présence:', err);
            });
        };

        const handleVisibilityChange = () => {
            isTabActive.current = !document.hidden;
            if (isTabActive.current) sendPresencePing();
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);

        sendPresencePing();
        pingIntervalRef.current = setInterval(sendPresencePing, 30000);

        return () => {
            if (pingIntervalRef.current) clearInterval(pingIntervalRef.current);
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, [user?.id, user?.username, isWatchingVideo]);
};

export default usePresencePing;